const ITEMS = ["Web Design", "Branding", "SEO", "Social Media", "PPC Ads", "Video Production", "Sacramento"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee" className="relative py-6 sm:py-8 border-y border-line overflow-hidden bg-surface/40">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-6 sm:gap-8 mx-6 sm:mx-8 font-head font-black tracking-tighter text-4xl sm:text-6xl text-text-2/25">
            {t}
            <span className="text-accent text-2xl sm:text-3xl leading-none">&#10022;</span>
          </span>
        ))}
      </div>
    </section>
  );
};
